import OktaAuth from '@okta/okta-auth-js';
import { useEffect, useState } from 'react';
//This servie should not depend on shell to avoid circular dependencies
import { loginToCapsPlus } from '../../../apps/shell/src/services/authService';
import { oktaConfig } from './oktaConfig';

const oktaAuthClient = window.__OKTA_CLIENT__
  ? window.__OKTA_CLIENT__
  : new OktaAuth(oktaConfig);

window.__OKTA_CLIENT__ = oktaAuthClient;

const redirectToMyCnC = () => {
  window.location.href = `${import.meta.env.VITE_APP_MYCNC_BASE_URL
    }/login?fromURI=${window.location.origin}`;
};

const withAuthGuard = (Component, options = { customScreenLoader: null }) => {
  return function AuthGuardedComponent(props) {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [accessToken, setAccessToken] = useState(null);
    const [internalToken, setInternalToken] = useState(null);

    useEffect(() => {
      let isSubscribed = true;

      const initAuth = async () => {
        try {
          oktaAuthClient.authStateManager.subscribe(async (authState) => {
            if (!isSubscribed) return;
            if (!authState.isAuthenticated) {
              const exists = await oktaAuthClient.session.exists();
              if (exists) {
                console.log('Session exists, getting tokens...');
                await oktaAuthClient.token.getWithRedirect({
                  responseType: ['id_token', 'token'],
                  scopes: ['openid', 'profile', 'email'],
                });
              } else {
                console.log('No session - redirecting to login');
                setIsLoading(false);
                redirectToMyCnC();
              }
            } else {
              const accessToken = authState.accessToken.accessToken;
              setAccessToken(accessToken);
              const response = await loginToCapsPlus(accessToken);
              if (response && response.success) {
                setInternalToken(response.capsplus_token);
                setIsAuthenticated(true);
              }
              setIsLoading(false);
            }
          });

          await oktaAuthClient.start();

          if (oktaAuthClient.isLoginRedirect()) {
            await oktaAuthClient.handleLoginRedirect();
          }
        } catch (error) {
          console.error('Auth error:', error);
          setIsLoading(false);
          redirectToMyCnC();
        }
      };

      initAuth();

      return () => {
        isSubscribed = false;
      };
    }, []);

    // Show loading state while authenticating
    if (isLoading) {
      if (options?.customScreenLoader) {
        return options.customScreenLoader();
      }

      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          Loading authentication...
        </div>
      );
    }

    // Don't render component until authenticated
    if (!isAuthenticated) {
      return null;
    }

    // Render protected component only when authenticated
    return (
      <Component
        authState={{ isAuthenticated, accessToken, internalToken }}
        {...props}
      />
    );
  };
};

export default withAuthGuard;
